import { apiGet, apiPost } from '../services/api';

export interface BroadcastMessage {
  id: number;
  message: string;
  branch_id: number | null;
  is_all_branches: boolean;
  created_at: string;
  updated_at: string;
  user?: {
    id: number;
    name: string;
    email: string;
  };
  branch?: {
    id: number;
    name: string;
  };
}

export interface PublishMessageParams {
  message: string;
  branch_id?: number | null;
  is_all_branches: boolean;
}

export interface GetMessagesParams {
  per_page?: number;
  page?: number;
}

export interface GetMessagesResult {
  data: BroadcastMessage[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export async function publishMessage(params: PublishMessageParams): Promise<BroadcastMessage> {
  return apiPost<BroadcastMessage>('/api/messages/publish', params);
}

export async function getMessages(params: GetMessagesParams = {}): Promise<GetMessagesResult> {
  const queryParams = new URLSearchParams();
  
  if (params.per_page) queryParams.append('per_page', params.per_page.toString());
  if (params.page) queryParams.append('page', params.page.toString());

  const response = await apiGet<GetMessagesResult>(
    `/api/messages?${queryParams.toString()}`,
  );

  return response;
}

